import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["backButton", "backLabel", "cancelButton", "cancelLabel", "doneButton", "doneLabel", "hidePrimaryControls", "hideSecondaryControls", "isFirstStep", "isLastStep", "nextButton", "nextLabel"];
import { DialogBody } from '../DialogBody';
import { jsx as _jsx } from "react/jsx-runtime";
export const WizardStep = _ref => {
  let rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(DialogBody, Object.assign({
    paddingBlock: "1000"
  }, rest));
};
WizardStep.displayName = 'WizardStep';